import _ from 'lodash';
import StoreService from '@topgeschenken/front-library/services/StoreService';

const storeService = new StoreService('/geography/countries', {
  identifier: 'code',
  defaultFilters: {
    pagination: false,
  },
});

const state = () => ({
  ...storeService.getState(),
});

const actions = {
  ...storeService.getActions(),
};

const mutations = {
  ...storeService.getMutations(),
};

const getters = {
  getSortedByName: (state) => {
    return _.sortBy(state.list, 'name');
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
